// timer — web app entry (CRA).
// Import order matters: theme base first, then app-specific overrides.
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './styles/theme/index.css';
import './styles/theme/theme.css';
import './index.css';

const container = document.getElementById('root');
const root = ReactDOM.createRoot(container);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
